import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-37583198"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "footer fr"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "version"
}, "湖北省应急管理厅  应急教育培训考核综合管理平台 BETA0.9"), /*#__PURE__*/_createElementVNode("p", {
  class: "technical-support"
}, "武汉聚一科技有限公司 提供技术支持"), /*#__PURE__*/_createElementVNode("div", {
  class: "fr"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "phone"
}, "技术支持热线: 027 - 88888888")]), /*#__PURE__*/_createElementVNode("div", {
  class: "clear"
})], -1));

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "clear"
}, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Header = _resolveComponent("Header");

  const _component_el_header = _resolveComponent("el-header");

  const _component_router_view = _resolveComponent("router-view");

  const _component_el_main = _resolveComponent("el-main");

  const _component_el_footer = _resolveComponent("el-footer");

  const _component_el_container = _resolveComponent("el-container");

  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_container, null, {
    default: _withCtx(() => [_createVNode(_component_el_header, null, {
      default: _withCtx(() => [_createVNode(_component_Header)]),
      _: 1
    }), _createVNode(_component_el_main, null, {
      default: _withCtx(() => [_createVNode(_component_router_view)]),
      _: 1
    }), _createVNode(_component_el_footer, null, {
      default: _withCtx(() => [_hoisted_1, _hoisted_2]),
      _: 1
    })]),
    _: 1
  })]);
}